var map = {
	"./Afghanistan.png": 2154,
	"./Albania.png": 4787,
	"./Algeria.png": 1050,
	"./Andorra.png": 2650,
	"./Angola.png": 7855,
	"./Argentina.png": 8902,
	"./Armenia.png": 3961,
	"./Australia.png": 626,
	"./Austria.png": 4885,
	"./Azerbaijan.png": 3882,
	"./Bahrain.png": 4551,
	"./Bangladesh.png": 172,
	"./Belarus.png": 4146,
	"./Belgium.png": 9565,
	"./Bermuda.png": 5257,
	"./Bolivia.png": 8174,
	"./Bosnia and herzegovina.png": 3875,
	"./Botswana.png": 8629,
	"./Brazil.png": 1933,
	"./Brunei.png": 4335,
	"./Bulgaria.png": 9433,
	"./Burkina faso.png": 424,
	"./Burundi.png": 746,
	"./Cambodia.png": 8455,
	"./Cameroon.png": 6159,
	"./Canada.png": 1604,
	"./Central african republic.png": 3165,
	"./Chad.png": 6496,
	"./Chile.png": 4170,
	"./China.png": 8846,
	"./Colombia.png": 1169,
	"./Costa rica.png": 8529,
	"./Croatia.png": 751,
	"./Cuba.png": 4524,
	"./Cyprus.png": 897,
	"./Czech republic.png": 9738,
	"./DRCongo.png": 3853,
	"./Denmark.png": 4540,
	"./Dominica.png": 6081,
	"./Dominican republic.png": 4421,
	"./Ecuador.png": 5498,
	"./Egypt.png": 1492,
	"./El salvador.png": 1621,
	"./England.png": 4122,
	"./Estonia.png": 5977,
	"./Eswatini.png": 6974,
	"./Ethiopia.png": 4899,
	"./Faroe islands.png": 4808,
	"./Fiji.png": 6918,
	"./Finland.png": 4607,
	"./France.png": 5176,
	"./Gabon.png": 4639,
	"./Gambia.png": 1470,
	"./Georgia.png": 683,
	"./Germany.png": 1413,
	"./Ghana.png": 378,
	"./Greece.png": 5618,
	"./Guatemala.png": 8002,
	"./Guinea.png": 9562,
	"./Guyana.png": 1624,
	"./Haiti.png": 7333,
	"./Honduras.png": 6468,
	"./Hong kong.png": 7128,
	"./Hungary.png": 5011,
	"./Iceland.png": 5930,
	"./India.png": 7330,
	"./Indonesia.png": 9744,
	"./Iran.png": 7335,
	"./Iraq.png": 3852,
	"./Ireland.png": 191,
	"./Israel.png": 8524,
	"./Italy.png": 4311,
	"./Ivory coast.png": 6891,
	"./Jamaica.png": 185,
	"./Japan.png": 1133,
	"./Jordan.png": 3934,
	"./Kazakhstan.png": 1640,
	"./Kenya.png": 8612,
	"./Kosovo.png": 1134,
	"./Kuwait.png": 3702,
	"./Kyrgyzstan.png": 7510,
	"./Laos.png": 7964,
	"./Latvia.png": 8335,
	"./Lebanon.png": 4730,
	"./Lesotho.png": 5396,
	"./Liberia.png": 3176,
	"./Libya.png": 8069,
	"./Lithuania.png": 1689,
	"./Luxembourg.png": 8783,
	"./Madagascar.png": 1117,
	"./Malawi.png": 5966,
	"./Malaysia.png": 2796,
	"./Mali.png": 313,
	"./Malta.png": 4733,
	"./Mauritania.png": 6118,
	"./Mauritus.png": 7846,
	"./Mexico.png": 7234,
	"./Moldova.png": 5227,
	"./Mongolia.png": 9976,
	"./Montenegro.png": 4215,
	"./Morocco.png": 8012,
	"./Mozambique.png": 9587,
	"./Namibia.png": 8840,
	"./Nepal.png": 6376,
	"./Netherlands.png": 3703,
	"./New zealand.png": 4089,
	"./Nicaragua.png": 5625,
	"./Niger.png": 1013,
	"./Nigeria.png": 9798,
	"./North macedonia.png": 110,
	"./Northern ireland.png": 5096,
	"./Norway.png": 7015,
	"./Oman.png": 2572,
	"./Pakistan.png": 2360,
	"./Palestine.png": 6746,
	"./Panama.png": 4185,
	"./Paraguay.png": 1785,
	"./Peru.png": 9452,
	"./Philippines.png": 2173,
	"./Poland.png": 5652,
	"./Portugal.png": 3831,
	"./Qatar.png": 1029,
	"./Republic of the congo.png": 5306,
	"./Romania.png": 4837,
	"./Russia.png": 4201,
	"./Rwanda.png": 4626,
	"./San marino.png": 2565,
	"./Saudi arabia.png": 6194,
	"./Scotland.png": 6228,
	"./Senegal.png": 6607,
	"./Serbia.png": 4584,
	"./Sierra leone.png": 6562,
	"./Singapore.png": 6625,
	"./Slovakia.png": 460,
	"./Slovenia.png": 1677,
	"./Somalia.png": 3721,
	"./South africa.png": 1293,
	"./South korea.png": 2022,
	"./Spain.png": 5779,
	"./Sri lanka.png": 9119,
	"./Sudan.png": 4767,
	"./Sweden.png": 7657,
	"./Switzerland.png": 9527,
	"./Syria.png": 5368,
	"./Tajikistan.png": 686,
	"./Tanzania.png": 2698,
	"./Thailand.png": 6584,
	"./Togo.png": 1299,
	"./Tonga.png": 9,
	"./Trinidad and tobago.png": 8952,
	"./Tunisia.png": 875,
	"./Turkey.png": 3435,
	"./Turkmenistan.png": 2769,
	"./Uganda.png": 39,
	"./Ukraine.png": 948,
	"./United arab emirates.png": 919,
	"./Uruguay.png": 7288,
	"./Usa.png": 2050,
	"./Uzbekistan.png": 5553,
	"./Venezuela.png": 603,
	"./Vietnam.png": 4673,
	"./Wales.png": 9911,
	"./Yemen.png": 3634,
	"./Zambia.png": 4500,
	"./Zimbabwe.png": 4351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1676;